var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 27C27.761 27 30 29.239 30 32C30 34.761 27.761 37 25 37C22.238 37 20 34.761 20 32C20 29.239 22.238 27 25 27ZM40 23C40 21.343 38.656 20 37 20C35.343 20 34 21.343 34 23C34 23.312 34.061 23.606 34.148 23.888L29.939 27.045C30.412 27.516 30.816 28.054 31.14 28.644L35.337 25.496C35.814 25.813 36.385 26 37 26C38.656 26 40 24.657 40 23ZM34.148 40.112C34.061 40.394 34 40.688 34 41C34 42.657 35.343 44 37 44C38.656 44 40 42.657 40 41C40 39.343 38.656 38 37 38C36.385 38 35.814 38.187 35.338 38.504L31.141 35.356C30.817 35.946 30.412 36.484 29.94 36.955L34.148 40.112ZM41 35.062C42.656 35.062 44 33.719 44 32.062C44 30.405 42.656 29.062 41 29.062C39.719 29.062 38.633 29.869 38.203 31H31.92C31.967 31.328 32 31.66 32 32C32 32.34 31.967 32.672 31.92 33H38.164C38.559 34.195 39.672 35.062 41 35.062Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a70d5f71.svg";
export { ForwardRef as ReactComponent };